import TAG_ICON from '@/assets/images/icons/tagfilled.png'
import BUILDING_ICON from '@/assets/images/icons/building.png'
import './ProductCard.style.less'

interface Props {
  description: string
  imageSrc: string
  itemNo: string
  hideSupplier?: boolean
  onClick?: () => void
  supplier: string
}

function ProductCard(props: Props) {
  const { description, hideSupplier, imageSrc, itemNo, onClick, supplier } =
    props

  return (
    <button className="product-card" type="button" onClick={onClick}>
      <img className="card-product-image" src={imageSrc} alt={description} />

      <div className="product-card-inner">
        <div className="product-card-header">
          <span className="product-item-number">{itemNo}</span>
        </div>
        <div
          className="product-card-content"
          style={{ flex: hideSupplier ? 0 : 1 }}
        >
          <p className="product-description">
            <img src={TAG_ICON} alt="" />
            <span>{description}</span>
          </p>
          {!hideSupplier && (
            <p>
              <img src={BUILDING_ICON} alt="" />
              <span>{supplier}</span>
            </p>
          )}
        </div>
      </div>
    </button>
  )
}

export default ProductCard
